export const timeAgo = (date: string | Date): string => {
	const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);

	if (seconds === 0) {
		return `Jetzt`;
	}

	if (seconds < 60) {
		return `vor ${seconds} ${seconds === 1 ? "Sekunde" : "Sekunden"}`;
	}

	const minutes = Math.floor(seconds / 60);

	if (minutes < 60) {
		return `vor ${minutes} ${minutes === 1 ? "Minute" : "Minuten"}`;
	}

	const hours = Math.floor(minutes / 60);

	if (hours < 24) {
		return `vor ${hours} ${hours === 1 ? "Stunde" : "Stunden"}`;
	}

	const days = Math.floor(hours / 24);

	if (days < 7) {
		return `vor ${days} ${days === 1 ? "Tag" : "Tagen"}`;
	}

	const weeks = Math.floor(days / 7);

	if (weeks < 4) {
		return `vor ${weeks} ${weeks === 1 ? "Woche" : "Wochen"}`;
	}

	const months = Math.floor(days / 30);

	if (months < 12) {
		return `vor ${months} ${months === 1 ? "Monat" : "Monaten"}`;
	}

	const years = Math.floor(days / 365);

	return `vor ${years} ${years === 1 ? "Jahr" : "Jahren"}`;
};
